module.exports = __webpack_public_path__ + "img/PW.146d3187.svg";